import {Component, ContentChild, Injector, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../../constants";
import {NgxSmartModalService} from "ngx-smart-modal";
import {Category} from "../../../models/category";
import {BaseComponent} from "../../base/base.component";
import {UserService} from "../../../services/user/user.service";
import {Router} from "@angular/router";

@Component({
    selector: 'ui-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss']
})
export class TableComponent extends BaseComponent implements OnInit {


    @Input('table-title') tableTitle: string = '';
    @Input('table-description') tableDescription: string = '';
    @Input('table-data') tableData: any[] = [];
    @Input('table-columns-to-show') tableColumnsToShow: string[] = [];

    @Input('striped') striped: boolean = false;
    @Input('addButtonText') addButtonText: string = '';
    @Input('deleteButtonText') deleteButtonText: string = '';
    @Input('editButtonText') editButtonText: string = '';
    @Input('printButtonText') printButtonText: string = '';
    @Input('shopTable') shopTable?: boolean = false;
    @Input('shopSubTotal') shopSubTotal?: number;


    @ContentChild("customHeader", {static: false})
    customHeaderRef: TemplateRef<any> | null = null;

    @ContentChild("customRow", {static: false})
    customRowRef: TemplateRef<any> | null = null;

    @ContentChild("customFilter", {static: false})
    customFilterRef: TemplateRef<any> | null = null;

    @ContentChild("customLoading", {static: false})
    customLoadingRef: TemplateRef<any> | null = null;

    rows: any[] = [];
    tableText: boolean = false;

    searchText: string | undefined;

    endpoint: string = '';
    params: any = {}
    defaultParams: any = {}
    currentPage: number = 0;
    pageSize: number = 30;
    pagesCount: number = 1;
    /** Numero totale di elementi restituito dal backend (tutte le pagine). */
    totalCount: number = 0;
    loading: boolean = false;
    convertFn: Function = () => {
    }

    @Input('addButtonCallback') addButtonCallback?: any
    @Input('addButtonParams') addButtonParams?: any;
    @Input('deleteButtonCallback') deleteButtonCallback?: any
    @Input('deleteButtonParams') deleteButtonParams?: any;
    @Input('editButtonCallback') editButtonCallback?: any
    @Input('editButtonParams') editButtonParams?: any;
    @Input('allowSearch') allowSearch: boolean = false;
    @Input() initialLoading = false;

    categories: Category[] = [];

    constructor(public userService: UserService,
                private http: HttpClient,
                public modal: NgxSmartModalService,
                public injectService: Injector,
                public router: Router) {
        super(injectService);
    }

    ngOnInit(): void {
        if (this.initialLoading) {
            this.loading = true;
        }
        this.tableText = this.tableTitle.length > 0
            || this.tableDescription.length > 0
            || this.allowSearch
            || this.addButtonText !== ''
            || this.deleteButtonText !== ''
            || this.editButtonText !== ''
            || this.printButtonText !== '';
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    private updateDefaultParams(params: any) {
        this.defaultParams = {...params};
        delete this.defaultParams['$skip'];
        delete this.defaultParams['$top'];
        delete this.defaultParams['text'];
    }

    async loadData(endpoint: string, params: any, convertFn: Function, resetPagination = false) {
        this.endpoint = endpoint
        this.params = params
        this.convertFn = convertFn

        let items = [];
        let response: any;

        if (!this.params) this.params = {}
        if (resetPagination) {
            this.updateDefaultParams(params);
            this.currentPage = 0;
        } else if (Object.keys(this.defaultParams).length === 0) {
            this.updateDefaultParams(params);
        }

        this.params['$skip'] = this.currentPage * this.pageSize
        this.params['$top'] = this.pageSize

        this.loading = true;

        try {
            response = await this.http.get(environment.apiUrl + endpoint, {
                params,
                headers: this.getRequestHeaders()
            }).toPromise();

            if (response.success) {
                items = response.data
                    .map((item: any) => {
                        return convertFn(item)
                    });

                this.pagesCount = Math.ceil(response.count / this.pageSize)
                this.totalCount = Number(response.count ?? items.length) || 0
            }
        } catch (e) {
            console.error('error getting items: ', e)
        }

        // console.log('table: ', items)
        this.rows = items
        this.loading = false;
    }

    async setData(data: any[]) {
        this.rows = data
        if (data) this.pagesCount = Math.ceil(data.length / this.pageSize)
        this.totalCount = data?.length ?? 0
    }

    loadPage(index: number) {
        this.currentPage = index;
        this.loadData(this.endpoint, this.params, this.convertFn)
    }

    reloadPage(){
        this.loadData(this.endpoint, this.params, this.convertFn)
    }

    nextPagePagination() {
        this.currentPage++;
        if (this.currentPage > this.pagesCount - 1) this.currentPage = this.pagesCount - 1
        this.loadData(this.endpoint, this.params, this.convertFn)
    }

    previousPagePagination() {
        this.currentPage--;
        if (this.currentPage < 0) this.currentPage = 0
        this.loadData(this.endpoint, this.params, this.convertFn)
    }


    async addElement() {

        if(this.addButtonCallback) await this.addButtonCallback(this.addButtonParams);

    }

    async deleteElement() {

        if(this.deleteButtonCallback) await this.deleteButtonCallback(this.deleteButtonParams);

    }
    async editElement() {

        if(this.editButtonCallback) await this.editButtonCallback(this.editButtonParams);

    }

    async printElement() {

        window.print();

    }

    searchElement() {
        this.params = {...this.defaultParams};
        if (this.searchText) {
            this.params['text'] = this.searchText;
        }
        this.loadData(this.endpoint, this.params, this.convertFn, true);
    }

    resetSearch() {
        this.searchText = '';
        this.params = {...this.defaultParams};
        this.loadData(this.endpoint, this.params, this.convertFn, true);
    }

    currentPageGroup: number = 0;

    getPagesArray(): number[] {
        const totalPages = this.pagesCount;
        const pagesToShow = 5;
        const startPage = this.currentPageGroup * pagesToShow;
        const endPage = Math.min(startPage + pagesToShow, totalPages);

        const pages: number[] = [];
        for (let i = startPage; i < endPage; i++) {
            pages.push(i + 1);
        }


        if (startPage > 0) {
            pages.unshift(-1);
        }
        if (endPage < totalPages) {
            pages.push(-2);
        }

        return pages;
    }

    loadPageGroup(direction: 'prev' | 'next') {
        const totalGroups = Math.ceil(this.pagesCount / 5);
        if (direction === 'prev' && this.currentPageGroup > 0) {
            this.currentPageGroup--;
        } else if (direction === 'next' && this.currentPageGroup < totalGroups - 1) {
            this.currentPageGroup++;
        }
    }

}
